/* =========================================================================
   Modded Moto Co — Wishlist
   Self-contained, dependency-free. Stores saved products in the visitor's
   browser (localStorage). Does NOT touch the cart except via Shopify's
   standard /cart/add.js endpoint when the customer chooses "Add to cart"
   from the wishlist page.
   ========================================================================= */
(function () {
  'use strict';

  var KEY = 'mmco_wishlist_v1';
  var PAGE_URL = '/pages/wishlist';

  /* ---------- storage ---------- */
  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
    notify();
  }
  function has(handle) {
    return read().some(function (i) { return i.handle === handle; });
  }
  function add(item) {
    var arr = read();
    if (!arr.some(function (i) { return i.handle === item.handle; })) {
      arr.unshift(item);
      write(arr);
    }
  }
  function remove(handle) {
    write(read().filter(function (i) { return i.handle !== handle; }));
  }
  function toggle(item) {
    if (has(item.handle)) { remove(item.handle); return false; }
    add(item);
    return true;
  }
  function count() { return read().length; }

  /* ---------- pub/sub ---------- */
  var listeners = [];
  function subscribe(cb) { listeners.push(cb); }
  function notify() {
    var c = count();
    listeners.forEach(function (cb) { try { cb(c); } catch (e) {} });
    syncButtons();
    syncLauncher();
  }

  window.MMCOWishlist = {
    read: read, has: has, add: add, remove: remove,
    toggle: toggle, count: count, subscribe: subscribe,
    KEY: KEY, PAGE_URL: PAGE_URL
  };

  /* ---------- helpers ---------- */
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function cssAttr(s) { return String(s == null ? '' : s).replace(/"/g, '\\"'); }
  function heartSVG() {
    return '<svg class="mmco-heart" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
  }

  /* ---------- product hearts ---------- */
  function itemFromBtn(btn) {
    return {
      handle: btn.getAttribute('data-wishlist-handle'),
      id: btn.getAttribute('data-wishlist-id'),
      title: btn.getAttribute('data-wishlist-title') || '',
      url: btn.getAttribute('data-wishlist-url') || '',
      image: btn.getAttribute('data-wishlist-image') || '',
      price: btn.getAttribute('data-wishlist-price') || ''
    };
  }
  function setBtnState(btn, active) {
    btn.classList.toggle('is-wished', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var added = btn.getAttribute('data-label-added');
    var addl = btn.getAttribute('data-label-add');
    if (added && addl) btn.setAttribute('aria-label', active ? added : addl);
  }
  function syncButtons(root) {
    var scope = root || document;
    var btns = scope.querySelectorAll('.mmco-wish-btn');
    for (var i = 0; i < btns.length; i++) {
      setBtnState(btns[i], has(btns[i].getAttribute('data-wishlist-handle')));
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.mmco-wish-btn') : null;
    if (!btn) return;
    /* keep clicks off the card's stretched link / product link */
    e.preventDefault();
    e.stopPropagation();
    var item = itemFromBtn(btn);
    if (!item.handle) return;
    var active = toggle(item);
    setBtnState(btn, active);
    btn.classList.add('mmco-pulse');
    setTimeout(function () { btn.classList.remove('mmco-pulse'); }, 320);
  }, false);

  /* ---------- floating launcher (appears once items are saved) ---------- */
  function buildLauncher() {
    if (document.getElementById('mmco-wishlist-launcher')) return;
    if (!document.body) return;
    var a = document.createElement('a');
    a.id = 'mmco-wishlist-launcher';
    a.href = PAGE_URL;
    a.innerHTML = '<span class="mmco-launcher-ico">' + heartSVG() + '</span>' +
      '<span class="mmco-launcher-text">Wishlist</span>' +
      '<span class="mmco-launcher-count" data-count>0</span>';
    document.body.appendChild(a);
    syncLauncher();
  }
  function syncLauncher() {
    var el = document.getElementById('mmco-wishlist-launcher');
    if (!el) return;
    var c = count();
    var cnt = el.querySelector('[data-count]');
    if (cnt) cnt.textContent = c;
    el.classList.toggle('is-visible', c > 0);
    el.setAttribute('aria-label', 'View your wishlist (' + c + ' item' + (c === 1 ? '' : 's') + ')');
  }

  /* ---------- wishlist page ---------- */
  var cfg = {};
  function readCfg(root) {
    cfg = {
      emptyText: root.getAttribute('data-empty-text') || 'Your wishlist is empty.',
      continueUrl: root.getAttribute('data-continue-url') || '/collections/all',
      continueText: root.getAttribute('data-continue-text') || 'Continue shopping',
      addText: root.getAttribute('data-add-text') || 'Add to cart',
      addingText: root.getAttribute('data-adding-text') || 'Adding…',
      addedText: root.getAttribute('data-added-text') || 'Added ✓',
      soldOutText: root.getAttribute('data-soldout-text') || 'Sold out',
      chooseText: root.getAttribute('data-choose-text') || 'Choose options'
    };
  }

  function renderPage() {
    var root = document.getElementById('mmco-wishlist-root');
    if (!root) return;
    readCfg(root);
    var items = read();

    if (!items.length) {
      root.innerHTML =
        '<div class="mmco-wishlist-empty">' +
          '<span class="mmco-wishlist-empty-ico">' + heartSVG() + '</span>' +
          '<p>' + escapeHtml(cfg.emptyText) + '</p>' +
          '<a class="mmco-btn mmco-btn--primary mmco-btn--auto" href="' + escapeHtml(cfg.continueUrl) + '">' +
            escapeHtml(cfg.continueText) + '</a>' +
        '</div>';
      return;
    }

    var grid = document.createElement('div');
    grid.className = 'mmco-wishlist-grid';
    items.forEach(function (item) { grid.appendChild(renderCard(item)); });
    root.innerHTML = '';
    root.appendChild(grid);
    items.forEach(function (item) { refreshCard(item); });
  }

  function renderCard(item) {
    var card = document.createElement('div');
    card.className = 'mmco-wcard';
    card.setAttribute('data-handle', item.handle);
    var media = item.image
      ? '<a href="' + escapeHtml(item.url) + '" class="mmco-wcard-media"><img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy"></a>'
      : '<a href="' + escapeHtml(item.url) + '" class="mmco-wcard-media mmco-wcard-media--empty"></a>';
    card.innerHTML =
      '<button class="mmco-wcard-remove" type="button" aria-label="Remove from wishlist" data-remove>&times;</button>' +
      media +
      '<div class="mmco-wcard-body">' +
        '<a class="mmco-wcard-title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' +
        '<div class="mmco-wcard-price">' + escapeHtml(item.price) + '</div>' +
        '<div class="mmco-wcard-actions" data-actions>' +
          '<button class="mmco-btn mmco-btn--disabled" type="button" disabled>' + escapeHtml(cfg.addText) + '</button>' +
        '</div>' +
      '</div>';
    card.querySelector('[data-remove]').addEventListener('click', function () {
      remove(item.handle);
      if (card.parentNode) card.parentNode.removeChild(card);
      if (!read().length) renderPage();
    });
    return card;
  }

  function refreshCard(item) {
    var base = (item.url || '').split('?')[0];
    if (!base) return;
    fetch(base + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var card = document.querySelector('.mmco-wcard[data-handle="' + cssAttr(item.handle) + '"]');
        if (!card) return;
        var actions = card.querySelector('[data-actions]');
        if (!actions) return;

        if (!p) {
          actions.innerHTML = '<a class="mmco-btn mmco-btn--ghost" href="' + escapeHtml(item.url) + '">View product</a>';
          return;
        }
        if (!p.available) {
          card.classList.add('is-soldout');
          actions.innerHTML = '<button class="mmco-btn mmco-btn--disabled" type="button" disabled>' + escapeHtml(cfg.soldOutText) + '</button>';
          return;
        }
        if (p.variants && p.variants.length === 1) {
          actions.innerHTML = '<button class="mmco-btn mmco-btn--primary" type="button" data-add="' + p.variants[0].id + '">' + escapeHtml(cfg.addText) + '</button>';
          wireAdd(card);
        } else {
          actions.innerHTML = '<a class="mmco-btn mmco-btn--primary" href="' + escapeHtml(item.url) + '">' + escapeHtml(cfg.chooseText) + '</a>';
        }
      })
      .catch(function () {});
  }

  function wireAdd(card) {
    var btn = card.querySelector('[data-add]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      addToCart(btn.getAttribute('data-add'), btn);
    });
  }

  function addToCart(variantId, btn) {
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = cfg.addingText;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && res.d.description) || 'Could not add to cart');
        btn.textContent = cfg.addedText;
        /* Refresh the theme's cart UI + UpCart drawer without disturbing contents */
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
        try { if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart(); } catch (e) {}
        toast(cfg.addedText, false, true);
        setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 1800);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = original;
        toast(err.message || 'Could not add to cart', true);
      });
  }

  /* ---------- toast ---------- */
  function toast(msg, isError, withCartLink) {
    var t = document.createElement('div');
    t.className = 'mmco-toast' + (isError ? ' mmco-toast--error' : '');
    t.innerHTML = '<span>' + escapeHtml(msg) + '</span>' +
      (withCartLink ? '<a href="/cart">View cart</a>' : '');
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(function () {
      t.classList.remove('is-on');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 300);
    }, 3200);
  }

  /* ---------- init ---------- */
  function init() {
    buildLauncher();
    syncButtons();
    renderPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* keep hearts in sync as themes inject product cards (filters, pagination) */
  var moTimer;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(function () { syncButtons(); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* multi-tab + bfcache sync */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      syncButtons();
      syncLauncher();
      if (document.getElementById('mmco-wishlist-root')) renderPage();
    }
  });
  window.addEventListener('pageshow', function () { syncButtons(); syncLauncher(); });
})();
